module.exports = __webpack_public_path__ + "img/yodlee-default.c1a3a892.svg";